import React, { createContext, useState, useContext } from 'react';

const CurationMapContext = createContext();
const CurationMapContentContext = createContext();
const CurationMapHoverContext = createContext();

export const useCurationMapContext = () => {
  return useContext(CurationMapContext);
};

export const useCurationMapContentContext = () => {
  return useContext(CurationMapContentContext);
};

export const useCurationMapHoverContext = () => {
  return useContext(CurationMapHoverContext);
};

export const CurationMapProvider = ({ children }) => {
  const [curationMapConfig, setCurationMapConfig] = useState(null);


  const resetCurationMapConfig = () => {
    setCurationMapConfig(null);
  }

  return (
    <CurationMapContext.Provider value={{ curationMapConfig, setCurationMapConfig, resetCurationMapConfig }}>
      {children}
    </CurationMapContext.Provider>
  );
};

export const CurationMapContentProvider = ({ children }) => {
  const [curationMapPopup, setCurationMapPopup] = useState(null);


  const resetCurationMapPopup = () => {
    setCurationMapPopup(null);
  }

  return (
    <CurationMapContentContext.Provider value={{ curationMapPopup, setCurationMapPopup, resetCurationMapPopup }}>
      {children}
    </CurationMapContentContext.Provider>
  );
};

export const CurationMapHoverProvider = ({ children }) => {
  const [curationHoverId, setCurationHoverId] = useState(null);


  const resetCurationHoverId = () => {
    setCurationHoverId(null);
  }

  return (
    <CurationMapHoverContext.Provider value={{ curationHoverId, setCurationHoverId, resetCurationHoverId }}>
      {children}
    </CurationMapHoverContext.Provider>
  );
};